module.exports = __webpack_public_path__ + "img/icon-amount-pellets-palet.8634f78.svg";